/*
export const someAction = (state) => {}
 */
import _debounce from 'lodash.debounce';
import _throttle from 'lodash.throttle';

// eslint-disable-next-line
export const subscribeViewport = ({ commit, state: { breakpoints } }) => {
  const setViewportData = () => {
    const { innerWidth, innerHeight } = window;
    commit('setWidth', innerWidth);
    commit('setHeight', innerHeight);

    const viewportTypes = ['xs', 'sm', 'md', 'lg'];

    const viewport = {
      xs: false,
      sm: false,
      md: false,
      lg: false,
      gt: {
        xs: false,
        sm: false,
        md: false,
        lg: false,
      },
      lt: {
        xs: false,
        sm: false,
        md: false,
        lg: false,
      },
    };

    const getViewportNames = (width) => {
      let viewportName;
      let higherViewportName;
      if (width >= breakpoints.md) {
        viewportName = 'lg';
        higherViewportName = 'lg';
      } else if (width >= breakpoints.sm) {
        viewportName = 'md';
        higherViewportName = 'lg';
      } else if (width >= breakpoints.xs) {
        viewportName = 'sm';
        higherViewportName = 'md';
      } else {
        viewportName = 'xs';
        higherViewportName = 'sm';
      }
      return {
        viewportName,
        higherViewportName,
      };
    };

    const { viewportName, higherViewportName } = getViewportNames(innerWidth);
    viewport[viewportName] = true;
    viewport.name = viewportName;
    viewport.higherViewportName = higherViewportName;

    const otherViewportsNames = viewportTypes.filter(v => v !== viewportName);
    otherViewportsNames.forEach((v) => {
      viewport[v] = false;
    });

    const viewportIndex = viewportTypes.indexOf(viewportName);

    const lowerViewports = viewportTypes.slice(0, viewportIndex);
    lowerViewports.forEach((v) => {
      viewport.gt[v] = true;
    });

    const higherViewports = viewportTypes.slice(viewportIndex + 1, viewportTypes.length);
    higherViewports.forEach((v) => {
      viewport.lt[v] = true;
    });

    commit('setViewport', viewport);
  };

  setViewportData();

  const debouncedSetViewportData = _debounce(setViewportData, 200);

  window.addEventListener('resize', debouncedSetViewportData);
};

export const subscribeWindowScroll = ({ commit }) => {
  const setWindowScroll = () => {
    const {
      scrollY,
      scrollX,
    } = window;
    const scrollObj = {
      y: scrollY,
      x: scrollX,
    };
    commit('setScroll', scrollObj);
  };
  const throttled = _throttle(setWindowScroll, 100);
  window.addEventListener('scroll', throttled);
};
